(ns app.front.view.case-description.subs
  (:require [app.front.process :as process]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.view.workspace.subs :as ws-subs]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-db ::select-priority
  (fn [db [_ priority]]
    (assoc-in db [::case-description ::selected-priority] priority)))


(rf/reg-event-db ::set-in-proximity
  (fn [db [_ value]]
    (assoc-in db [::case-description ::selected-in-proximity] value)))


(rf/reg-event-db ::set-non-owner-violation
  (fn [db [_ value]]
    (assoc-in db [::case-description ::selected-non-owner-violation] value)))


(rf/reg-event-db ::allow-editing
  (fn [db [_ key]]
    (assoc-in db [::case-description :editing key] true)))


(rf/reg-event-db ::disallow-editing
  (fn [db [_ key]]
    (assoc-in db [::case-description :editing key] false)))


(rf/reg-event-db ::update-edited-description
  (fn [db [_ key description]]
    (assoc-in db [::case-description :edited-description key] description)))


(rf/reg-event-db ::clear-edited-description
  (fn [db [_ key]]
    (p/dissoc-in db [::case-description :edited-description key])))


(rf/reg-event-fx ::save-description
  (fn [{:keys [db]} [_ target signal edited-description-key]]
    {:dispatch [::process/signal target [signal {:value (-> db ::case-description :edited-description edited-description-key)}]
                {:on-success [::save-description.success edited-description-key]
                 :notify     {:success (if (= edited-description-key :description)
                                         :case/description-saved
                                         :case/description-of-location-saved)}}]}))


(rf/reg-event-fx ::save-description.success
  (fn [_ [_ edited-description-key _ _]]
    {:fx [[:dispatch [::disallow-editing edited-description-key]]
          [:dispatch [::clear-edited-description edited-description-key]]]}))


(rf/reg-event-db ::clear-description-data
  (fn [db _]
    (dissoc db ::case-description)))


(rf/reg-event-db ::toggle-limited-visibility-view-data
  (fn [db _]
    (update-in db [:view/workspace :limited-visibility-for-other-departments] not)))


(rf/reg-sub ::case-description
  :<- [::ws-subs/workspace]
  :-> :workspace/case-description)


(rf/reg-sub ::case-description-of-location
  :<- [::ws-subs/workspace]
  :-> :workspace/case-description-of-location)


(rf/reg-sub ::saved-priority
  :<- [::ws-subs/workspace]
  :-> :workspace/case-priority)


(rf/reg-sub ::saved-in-proximity
  :<- [::ws-subs/workspace]
  (fn [ws _]
    (-> ws :workspace/case-in-proximity boolean)))


(rf/reg-sub ::saved-non-owner-violation
  :<- [::ws-subs/workspace]
  (fn [ws _]
    (-> ws :workspace/case-non-owner-violation boolean)))


(rf/reg-sub ::limited-visibility-for-other-departments
  :<- [::ws-subs/view-data]
  :-> :limited-visibility-for-other-departments)


(rf/reg-sub ::description-data
  :-> ::case-description)


(rf/reg-sub ::selected-priority
  :<- [::description-data]
  :-> ::selected-priority)


(rf/reg-sub ::selected-in-proximity
  :<- [::description-data]
  #(::selected-in-proximity % false))


(rf/reg-sub ::selected-non-owner-violation
  :<- [::description-data]
  #(::selected-non-owner-violation % false))


(rf/reg-sub ::description-save-disabled?
  :<- [::description-data]
  (fn [data [_ key]]
    (ui-rt/empty-texts? (-> data :edited-description key))))


(rf/reg-sub ::editing?
  :<- [::description-data]
  (fn [data [_ key]]
    (-> data :editing key)))


(rf/reg-sub ::edited-description
  :<- [::description-data]
  (fn [data [_ key]]
    (-> data :edited-description key)))
